export default __webpack_public_path__ + "static/media/partnershipProfile.e56b5dfc.png";